// import { UPDATE_NEW_PAYMENT } from "helpers/url_helper";
import {
  ADD_NEW_Payment,
  ADD_NEW_Payment_SUCCESS,
  ADD_NEW_Payment_FAIL,
  GET_PARTICIPANT_PAYMENT,
  GET_PARTICIPANT_PAYMENT_SUCCESS,
  GET_PARTICIPANT_PAYMENT_FAIL,
  GET_PARTICIPANT_SCHEME_LIST,
  GET_PARTICIPANT_SCHEME_LIST_SUCCESS,
  GET_PARTICIPANT_SCHEME_LIST_FAIL,
  UPDATE_NEW_PAYMENT,
  UPDATE_NEW_PAYMENT_SUCCESS,
  UPDATE_NEW_PAYMENT_FAIL,
  GET_DELETED_PAYMENTS,
  GET_DELETED_PAYMENTS_SUCCESS,
  GET_DELETED_PAYMENTS_FAIL,
  DELETE_PAYMENT,
  DELETE_PAYMENT_SUCCESS,
  DELETE_PAYMENT_FAIL,
  CONFIRM_PAYMENT,
  CONFIRM_PAYMENT_SUCCESS,
  CONFIRM_PAYMENT_FAIL,
  GET_ANALYTE_REPORT2,
  GET_ANALYTE_REPORT2_SUCCESS,
  GET_ANALYTE_REPORT2_FAIL,
  GET_ANALYTE_EVALUATION_REPORT,
  GET_ANALYTE_EVALUATION_REPORT_SUCCESS,
  GET_ANALYTE_EVALUATION_REPORT_FAIL,
  GET_PARTICIPANT_PERFORMANCE_REPORT,
  GET_PARTICIPANT_PERFORMANCE_REPORT_SUCCESS,
  GET_PARTICIPANT_PERFORMANCE_REPORT_FAIL,
  GET_ANALYTE_EVALUATION_LAB,
  GET_ANALYTE_EVALUATION_LAB_SUCCESS,
  GET_ANALYTE_EVALUATION_LAB_FAIL,
  GET_FINANCIAL_FORECAST,
  GET_FINANCIAL_FORECAST_SUCCESS,
  GET_FINANCIAL_FORECAST_FAIL,
} from "./actionTypes";

export const addNewPayment = (id, payment) => {
  return {
    type: ADD_NEW_Payment,
    payload: { id, payment },
  };
};

export const addNewPaymentSuccess = (id, payment) => ({
  type: ADD_NEW_Payment_SUCCESS,
  payload: { id, payment },
});

export const addNewPaymentFail = (error) => ({
  type: ADD_NEW_Payment_FAIL,
  payload: error,
});
export const updatePayment = (payment) => {
  return {
    type: UPDATE_NEW_PAYMENT,
    payload: payment,
  };
};

export const updatePaymentSuccess = (payment) => {
  return {
    type: UPDATE_NEW_PAYMENT_SUCCESS,
    payload: payment,
  };
};

export const updatePaymentFail = (error) => {
  return {
    type: UPDATE_NEW_PAYMENT_FAIL,
    payload: error,
  };
};

export const getParticipantPayment = (id) => {
  return {
    type: GET_PARTICIPANT_PAYMENT,
    payload: id,
  };
};

export const getparticipantpaymentSuccess = (GetPayment) => ({
  type: GET_PARTICIPANT_PAYMENT_SUCCESS,
  payload: GetPayment,
});

export const getparticipantpaymentFail = (error) => ({
  type: GET_PARTICIPANT_PAYMENT_FAIL,
  payload: error,
});

///participant scheme list

export const getParticipantSchemelist = (id) => {
  return {
    type: GET_PARTICIPANT_SCHEME_LIST,
    payload: id,
  };
};

export const getParticipantSchemelistSuccess = (GetPayment) => ({
  type: GET_PARTICIPANT_SCHEME_LIST_SUCCESS,
  payload: GetPayment,
});

export const getParticipantSchemelistFail = (error) => ({
  type: GET_PARTICIPANT_SCHEME_LIST_FAIL,
  payload: error,
});
export const getDeletedPayments = (filters) => ({
  type: GET_DELETED_PAYMENTS,
  payload: filters,
});

export const getDeletedPaymentsSuccess = (payments) => ({
  type: GET_DELETED_PAYMENTS_SUCCESS,
  payload: payments,
});

export const getDeletedPaymentsFail = (error) => ({
  type: GET_DELETED_PAYMENTS_FAIL,
  payload: error,
});
export const deletePayment = (payment) => ({
  type: DELETE_PAYMENT,
  payload: payment,
});

export const deletePaymentSuccess = (id) => ({
  type: DELETE_PAYMENT_SUCCESS,
  payload: id,
});

export const deletePaymentFail = (error) => ({
  type: DELETE_PAYMENT_FAIL,
  payload: error,
});

export const confirmpayment = (payload) => ({
  type: CONFIRM_PAYMENT,
  payload, // must include both id and status
});

export const confirmpaymentSuccess = (GetPayment) => ({
  type: CONFIRM_PAYMENT_SUCCESS,
  payload: GetPayment,
});

export const confirmpaymentFail = (error) => ({
  type: CONFIRM_PAYMENT_FAIL,
  payload: error,
});

export const getanalytereport2 = (id) => {
  return {
    type: GET_ANALYTE_REPORT2,
    payload: id,
  };
};

export const getanalytereport2Success = (GetAnalyte) => ({
  type: GET_ANALYTE_REPORT2_SUCCESS,
  payload: GetAnalyte,
});

export const getanalytereport2Fail = (error) => ({
  type: GET_ANALYTE_REPORT2_FAIL,
  payload: error,
});
export const getanalyteevaluationreport = (id) => {
  return {
    type: GET_ANALYTE_EVALUATION_REPORT,
    payload: id,
  };
};

export const getanalyteevaluationreportSuccess = (GetAnalyte) => ({
  type: GET_ANALYTE_EVALUATION_REPORT_SUCCESS,
  payload: GetAnalyte,
});

export const getanalyteevaluationreportFail = (error) => ({
  type: GET_ANALYTE_EVALUATION_REPORT_FAIL,
  payload: error,
});

export const getparticipantperformancereport = (scheme_id, user_id) => ({
  type: GET_PARTICIPANT_PERFORMANCE_REPORT,
  payload: { scheme_id, user_id },
});

export const getparticipantperformancereportSuccess = (payload) => {
  return {
    type: GET_PARTICIPANT_PERFORMANCE_REPORT_SUCCESS,
    payload, // just forward the API response
  };
};

export const getparticipantperformancereportFail = (error) => {
  return {
    type: GET_PARTICIPANT_PERFORMANCE_REPORT_FAIL,
    payload: error,
  };
};

export const getanalyteevaluationLab = (id) => {
  return {
    type: GET_ANALYTE_EVALUATION_LAB,
    payload: id,
  };
};

export const getanalyteevaluationLabSuccess = (GetAnalyteEvaluationLab) => ({
  type: GET_ANALYTE_EVALUATION_LAB_SUCCESS,
  payload: GetAnalyteEvaluationLab,
});

export const getanalyteevaluationLabFail = (error) => ({
  type: GET_ANALYTE_EVALUATION_LAB_FAIL,
  payload: error,
});
export const getfinancialforecast = (id) => {
  return {
    type: GET_FINANCIAL_FORECAST,
    payload: id,
  };
};

export const getfinancialforecastSuccess = (GetFinancialForecast) => ({
  type: GET_FINANCIAL_FORECAST_SUCCESS,
  payload: GetFinancialForecast,
});

export const getfinancialforecastFail = (error) => ({
  type: GET_FINANCIAL_FORECAST_FAIL,
  payload: error,
});
